import { render } from "./EditFeedback.vue?vue&type=template&id=59c358ad"
import script from "./EditFeedback.vue?vue&type=script&lang=js"
export * from "./EditFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__